/* MIST - front-end interactions. Shared by theme + preview. */
(function () {
  "use strict";

  // Sticky header shadow on scroll
  var header = document.querySelector(".site-header");
  if (header) {
    var onScroll = function () {
      header.classList.toggle("is-scrolled", window.scrollY > 8);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  // Mobile nav toggle — opens the links as a dropdown under the header bar
  var toggle = document.querySelector(".nav-toggle");
  if (toggle && header) {
    toggle.addEventListener("click", function () {
      var open = header.classList.toggle("nav-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
    header.querySelectorAll(".site-nav a").forEach(function (a) {
      a.addEventListener("click", function () {
        header.classList.remove("nav-open");
        toggle.setAttribute("aria-expanded", "false");
      });
    });
  }

  // Reveal-on-scroll
  var revealEls = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window && revealEls.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add("is-visible"); });
  }

  // Home "Where to Find Us" logo rail: arrows scroll the row, disabled at either end
  document.querySelectorAll(".wild__rail").forEach(function (rail) {
    var track = rail.querySelector(".wild__track");
    var prev = rail.querySelector(".wild__arrow--prev");
    var next = rail.querySelector(".wild__arrow--next");
    if (!track || !prev || !next) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth - 4;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= max;
    }
    prev.addEventListener("click", function () { track.scrollBy({ left: -track.clientWidth * 0.8 }); });
    next.addEventListener("click", function () { track.scrollBy({ left: track.clientWidth * 0.8 }); });
    track.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  });

  // Find Mist page: stockist location panels (hover on desktop, tap the toggle anywhere)
  var stockists = Array.prototype.slice.call(document.querySelectorAll(".stockist"));
  if (stockists.length) {
    // Nudge a floating panel sideways so it never runs off the screen edge
    var placePanel = function (card) {
      var panel = card.querySelector(".stockist__panel");
      if (!panel || getComputedStyle(panel).position !== "absolute") return;
      panel.style.setProperty("--shift", "0px");
      var r = panel.getBoundingClientRect();
      var pad = 16, shift = 0;
      if (r.left < pad) shift = pad - r.left;
      else if (r.right > window.innerWidth - pad) shift = window.innerWidth - pad - r.right;
      panel.style.setProperty("--shift", Math.round(shift) + "px");
    };
    var closeAll = function (except) {
      stockists.forEach(function (c) {
        if (c === except) return;
        c.classList.remove("is-open");
        var t = c.querySelector(".stockist__toggle");
        if (t) t.setAttribute("aria-expanded", "false");
      });
    };
    stockists.forEach(function (card) {
      card.addEventListener("mouseenter", function () { placePanel(card); });
      var t = card.querySelector(".stockist__toggle");
      if (!t) return;
      t.addEventListener("click", function () {
        var open = !card.classList.contains("is-open");
        closeAll(card);
        card.classList.toggle("is-open", open);
        t.setAttribute("aria-expanded", open ? "true" : "false");
        if (open) placePanel(card);
      });
    });
    document.addEventListener("click", function (e) {
      if (!e.target.closest(".stockist")) closeAll();
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeAll(); });
  }

  // Find Mist page: highlight the pill for the category in view
  var findPills = document.querySelectorAll(".find-nav__pill");
  var findCats = document.querySelectorAll("[data-find-cat]");
  if (findPills.length && findCats.length && "IntersectionObserver" in window) {
    var catIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        findPills.forEach(function (p) {
          p.classList.toggle("is-active", p.getAttribute("href") === "#" + en.target.id);
        });
      });
    }, { rootMargin: "-45% 0px -50% 0px" });
    findCats.forEach(function (c) { catIo.observe(c); });
  }

  // Quantity steppers (− decreases, + increases)
  document.querySelectorAll(".product-pg__qty").forEach(function (q) {
    var btns = q.querySelectorAll("button");
    var out = q.querySelector("span");
    if (btns.length < 2 || !out) return;
    var input = q.querySelector("input");
    var n = parseInt(out.textContent, 10) || 1;
    function render() { out.textContent = n; if (input) input.value = n; }
    btns[0].addEventListener("click", function () { if (n > 1) { n--; render(); } });
    btns[1].addEventListener("click", function () { if (n < 99) { n++; render(); } });
  });

  // Product image carousel (arrows + thumbnails)
  function fitFor(s) { return "cover"; }
  document.querySelectorAll(".pcar").forEach(function (car) {
    var main = car.querySelector(".pcar__img");
    var thumbs = Array.prototype.slice.call(car.querySelectorAll(".pcar__thumb"));
    if (!main || !thumbs.length) return;
    var srcs = thumbs.map(function (t) { var im = t.querySelector("img"); return im ? (im.getAttribute("data-full") || im.getAttribute("src")) : ""; });
    thumbs.forEach(function (t) { var im = t.querySelector("img"); if (im) im.style.objectFit = fitFor(im.getAttribute("src")); });
    main.style.objectFit = fitFor(main.getAttribute("src"));
    var i = 0;
    function show(idx) {
      i = (idx + srcs.length) % srcs.length;
      main.setAttribute("src", srcs[i]);
      main.style.objectFit = fitFor(srcs[i]);
      thumbs.forEach(function (t, k) { t.classList.toggle("is-active", k === i); });
    }
    thumbs.forEach(function (t, k) { t.addEventListener("click", function () { show(k); }); });
    var prev = car.querySelector(".pcar__arrow--prev");
    var next = car.querySelector(".pcar__arrow--next");
    if (prev) prev.addEventListener("click", function () { show(i - 1); });
    if (next) next.addEventListener("click", function () { show(i + 1); });
  });

  /* Any add-to-cart form (home flavor cards + product page): add via AJAX and
     pop open the cart drawer showing the full cart — never redirect to /cart. */
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    var btn = form.querySelector('[name="add"], [type="submit"]');
    if (btn) btn.disabled = true;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: new FormData(form)
    })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () {
        if (window.MistCart) { window.MistCart.open(); }
        if (btn) btn.disabled = false;
      })
      .catch(function () { if (btn) btn.disabled = false; });
  });

  /* ---------- Shared cart helpers (used by the drawer and the full cart page) ---------- */
  var moneyFormat = (window.MIST && window.MIST.moneyFormat) || "{{amount}}";
  function formatMoney(cents) {
    var decimalsFor = { amount: 2, amount_no_decimals: 0, amount_with_comma_separator: 2, amount_no_decimals_with_comma_separator: 0 };
    return String(moneyFormat).replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, name) {
      var decimals = decimalsFor[name] != null ? decimalsFor[name] : 2;
      var n = (Number(cents) / 100).toFixed(decimals);
      var parts = n.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    }).replace(/<[^>]+>/g, "");
  }
  function updateCount(n) {
    var c = document.querySelector("[data-cart-count]") || document.querySelector(".cart-count");
    if (!c) return;
    c.textContent = n;
    if (n > 0) { c.removeAttribute("hidden"); } else { c.setAttribute("hidden", ""); }
  }
  function sized(src, size) {
    if (!src) return "";
    return src.replace(/(\.(?:jpg|jpeg|png|gif|webp))(\?.*)?$/i, "_" + size + "x$1$2");
  }

  /* ---------- Cart drawer (slide-out cart, add/remove without leaving the page) ---------- */
  var drawer = document.getElementById("cart-drawer");
  if (drawer) {
    var cartBody = drawer.querySelector("[data-cart-body]");
    var cartFoot = drawer.querySelector("[data-cart-foot]");
    var cartSubtotal = drawer.querySelector("[data-cart-subtotal]");

    function renderCart(cart) {
      updateCount(cart.item_count);
      if (!cartBody) return;
      if (cart.item_count === 0) {
        cartBody.innerHTML = '<div class="cart-drawer__empty">Your cart is empty.</div>';
        if (cartFoot) cartFoot.setAttribute("hidden", "");
        return;
      }
      if (cartFoot) cartFoot.removeAttribute("hidden");
      var html = "";
      var cartImages = (window.MIST && window.MIST.cartImages) || {};
      cart.items.forEach(function (item) {
        var imgSrc = cartImages[item.handle] || (item.image ? sized(item.image, 132) : "");
        html +=
          '<div class="cart-item" data-key="' + item.key + '">' +
            '<a class="cart-item__img" href="' + item.url + '">' +
              (imgSrc ? '<img src="' + imgSrc + '" alt="" loading="lazy">' : "") +
            "</a>" +
            '<div class="cart-item__info">' +
              '<a class="cart-item__title" href="' + item.url + '">' + item.product_title + "</a>" +
              '<div class="cart-item__price">' + formatMoney(item.final_line_price) + "</div>" +
              '<div class="cart-item__row">' +
                '<span class="cart-item__qty">' +
                  '<button type="button" data-qty-dec aria-label="Decrease quantity">&minus;</button>' +
                  "<span>" + item.quantity + "</span>" +
                  '<button type="button" data-qty-inc aria-label="Increase quantity">+</button>' +
                "</span>" +
                '<button type="button" class="cart-item__remove" data-remove>Remove</button>' +
              "</div>" +
            "</div>" +
          "</div>";
      });
      cartBody.innerHTML = html;
      if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.items_subtotal_price);
    }

    function fetchCart() {
      fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(renderCart)
        .catch(function () {});
    }

    function changeLine(key, qty) {
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(renderCart)
        .catch(function () {});
    }

    function openCart() {
      fetchCart();
      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
    }
    function closeCart() {
      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    }

    var opener = document.querySelector("[data-cart-open]");
    if (opener) opener.addEventListener("click", function (e) { e.preventDefault(); openCart(); });
    drawer.querySelectorAll("[data-cart-close]").forEach(function (el) {
      el.addEventListener("click", closeCart);
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeCart(); });

    if (cartBody) {
      cartBody.addEventListener("click", function (e) {
        var row = e.target.closest(".cart-item");
        if (!row) return;
        var key = row.getAttribute("data-key");
        var qtyEl = row.querySelector(".cart-item__qty span");
        var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        if (e.target.closest("[data-qty-inc]")) changeLine(key, qty + 1);
        else if (e.target.closest("[data-qty-dec]")) changeLine(key, Math.max(0, qty - 1));
        else if (e.target.closest("[data-remove]")) changeLine(key, 0);
      });
    }

    // expose so the add-to-cart button can refresh / open the drawer if desired
    window.MistCart = { open: openCart, close: closeCart, refresh: fetchCart };
  }

  /* ---------- Full cart page: live quantity + remove, no Update button ---------- */
  var cartForm = document.querySelector(".cart__form");
  if (cartForm) {
    function updateCartPage(cart) {
      updateCount(cart.item_count);
      var sub = document.querySelector("[data-cart-subtotal]");
      if (sub) sub.textContent = formatMoney(cart.total_price);
      if (cart.item_count === 0) { window.location.reload(); return; }
      var byKey = {};
      cart.items.forEach(function (it) { byKey[it.key] = it; });
      cartForm.querySelectorAll(".cart__item").forEach(function (li) {
        var it = byKey[li.getAttribute("data-key")];
        if (!it) { li.remove(); return; }
        var q = li.querySelector("[data-qty]"); if (q) q.textContent = it.quantity;
        var lt = li.querySelector("[data-line-total]"); if (lt) lt.textContent = formatMoney(it.final_line_price);
      });
    }
    function changeCartPage(key, qty) {
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(updateCartPage)
        .catch(function () {});
    }
    cartForm.addEventListener("click", function (e) {
      var li = e.target.closest(".cart__item");
      if (!li) return;
      var key = li.getAttribute("data-key");
      var qEl = li.querySelector("[data-qty]");
      var qty = qEl ? parseInt(qEl.textContent, 10) : 1;
      if (e.target.closest("[data-qty-inc]")) changeCartPage(key, qty + 1);
      else if (e.target.closest("[data-qty-dec]")) changeCartPage(key, Math.max(0, qty - 1));
      else if (e.target.closest("[data-remove]")) changeCartPage(key, 0);
    });
  }
})();
